import { render } from "./Alpha.vue?vue&type=template&id=6f2cb744&scoped=true&ts=true"
import script from "./Alpha.vue?vue&type=script&lang=ts"
export * from "./Alpha.vue?vue&type=script&lang=ts"

import "./Alpha.vue?vue&type=style&index=0&id=6f2cb744&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2cb744"]])

export default __exports__